"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/list/style");
var _list = _interopRequireDefault(require("antd/lib/list"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _fuzzy = _interopRequireDefault(require("fuzzy"));
var _utils = require("../../../utils");
var _mapMarker = _interopRequireDefault(require("../../../images/map-marker.svg"));
var _SelectPharmacy = _interopRequireDefault(require("../SelectPharmacy"));
var _FilterPharmacyForm = _interopRequireDefault(require("./FilterPharmacyForm"));
var _FilterPharmacySearchResults = _interopRequireDefault(require("./FilterPharmacySearchResults"));
require("./SelectPharmacyModal.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Title = _typography.default.Title;
var options = {
  extract: function extract(_ref) {
    var storeName = _ref.storeName,
      address1 = _ref.address1;
    return storeName + '::' + address1;
  },
  pre: '<b>',
  post: '</b>'
};
var SelectPharmacyModal = function SelectPharmacyModal(_ref2) {
  var visible = _ref2.visible,
    _ref2$onSelectPharmac = _ref2.onSelectPharmacy,
    onSelectPharmacy = _ref2$onSelectPharmac === void 0 ? _utils.noop : _ref2$onSelectPharmac,
    onCancel = _ref2.onCancel,
    _ref2$onSearch = _ref2.onSearch,
    onSearch = _ref2$onSearch === void 0 ? _utils.noop : _ref2$onSearch,
    _ref2$refetchPatients = _ref2.refetchPatientsPharmacies,
    refetchPatientsPharmacies = _ref2$refetchPatients === void 0 ? _utils.noop : _ref2$refetchPatients,
    _ref2$patientId = _ref2.patientId,
    patientId = _ref2$patientId === void 0 ? 'me' : _ref2$patientId,
    _ref2$patientAddress = _ref2.patientAddress,
    patientAddress = _ref2$patientAddress === void 0 ? {} : _ref2$patientAddress,
    currentPharmacies = _ref2.currentPharmacies;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    pharmacies = _useState4[0],
    setPharmacies = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loadingPharmacies = _useState6[0],
    setLoadingPharmacies = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    pharmaciesFiltered = _useState8[0],
    setPharmaciesFiltered = _useState8[1];
  (0, _react.useEffect)(function () {
    if (!visible) {
      setSearchString('');
      if (onSearch === _utils.noop) {
        search('');
      } else {
        onSearch('');
      }
    }
  }, [setSearchString, visible]);
  (0, _react.useEffect)(function () {
    var zip = patientAddress.zipCode;
    if (zip && visible) {
      handleFetchPharmacies({
        zip: zip
      });
    }
  }, [visible]);
  (0, _react.useEffect)(function () {
    if (pharmacies && pharmacies.length) {
      setPharmaciesFiltered(pharmacies);
    }
  }, [pharmacies]);
  var handleFetchPharmacies = function handleFetchPharmacies(values) {
    setLoadingPharmacies(true);
    var modalOuter = document.getElementsByClassName('select-pharmacy-modal');
    if (modalOuter && modalOuter.length) {
      var list = modalOuter[0].getElementsByClassName('ant-modal-body');
      if (list && list.length) {
        list[0].scrollTop = 0;
      }
    }
    _utils.api.get((0, _utils.getPatientPharmaciesUrl)(patientId, values)).then(function (result) {
      setLoadingPharmacies(false);
      setPharmacies(result.data);
    });
  };
  var search = function search(value) {
    var result = pharmacies;
    if (!(0, _lodash.isEmpty)(value)) {
      var pharmaciesPrepared = pharmacies.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          address1: (0, _utils.stripHtml)(item.address1),
          storeName: (0, _utils.stripHtml)(item.storeName)
        });
      });
      var fuzzyFound = _fuzzy.default.filter(value, pharmaciesPrepared, options);
      result = _toConsumableArray(fuzzyFound.map(function (item) {
        var _item$string$split = item.string.split('::'),
          _item$string$split2 = _slicedToArray(_item$string$split, 2),
          storeName = _item$string$split2[0],
          address1 = _item$string$split2[1];
        return _objectSpread(_objectSpread({}, item.original), {}, {
          storeName: storeName,
          address1: address1
        });
      }));
    }
    setPharmaciesFiltered(result);
  };
  var selectPharmacy = function selectPharmacy(selectedPharmacy) {
    var existingPharmacies = currentPharmacies && currentPharmacies.map(function (p) {
      return p.pharmacyId;
    });
    setLoadingPharmacies(true);
    _utils.api.post((0, _utils.getPatientPharmacyUrl)(selectedPharmacy.pharmacyId, patientId), {
      existingPharmacies: existingPharmacies
    }).then(function () {
      onCancel();
      _utils.toast.success({
        title: 'Success',
        description: 'Your preferred pharmacy has been saved.'
      });
      refetchPatientsPharmacies();
    });
  };
  return /*#__PURE__*/_react.default.createElement(_modal.default, {
    width: "492px",
    visible: visible,
    onCancel: onCancel,
    className: "select-pharmacy-modal",
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: "select-pharmacy-header"
    }, /*#__PURE__*/_react.default.createElement(Title, {
      level: 4,
      className: "label-small-medium"
    }, "Pharmacy Search"), /*#__PURE__*/_react.default.createElement(_FilterPharmacyForm.default, {
      zip: patientAddress.zipCode || '',
      onSubmit: handleFetchPharmacies
    }), /*#__PURE__*/_react.default.createElement(_FilterPharmacySearchResults.default, {
      searchString: searchString,
      setSearchString: setSearchString,
      onSearch: onSearch,
      search: search
    })),
    footer: null
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingPharmacies,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_list.default, {
    itemLayout: "horizontal",
    dataSource: pharmaciesFiltered,
    className: "pharmacies",
    renderItem: function renderItem(item) {
      return /*#__PURE__*/_react.default.createElement(_list.default.Item, {
        onClick: function onClick() {
          if (onSelectPharmacy === _utils.noop) {
            selectPharmacy(item);
          } else {
            onSelectPharmacy(item);
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_list.default.Item.Meta, {
        title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
          alt: "",
          src: _mapMarker.default
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "store-name",
          dangerouslySetInnerHTML: {
            __html: item.storeName
          }
        })),
        description: /*#__PURE__*/_react.default.createElement("span", {
          className: "pharmacy_address",
          dangerouslySetInnerHTML: {
            __html: item.address1
          }
        })
      }));
    }
  })));
};
_SelectPharmacy.default.propTypes = {
  visible: _propTypes.default.bool,
  onSearch: _propTypes.default.func,
  onSelectPharmacy: _propTypes.default.func,
  onCancel: _propTypes.default.func
};
var _default = SelectPharmacyModal;
exports.default = _default;